export default __webpack_public_path__ + "a72d6331d6380af18899aa7a9c672702.svg";